export default "__VITE_ASSET__PFRBr4OP__"